/* Source: /app/components/Layout/DockableConsole.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useMemo } from "react";
import { Terminal, AlertCircle, FileText, ChevronUp, ChevronDown, X, Eraser, Maximize2, Minimize2 } from "lucide-react";
import { cn } from "../../lib/utils.js";
import { useState } from "@jac/runtime";
function DockableConsole(props) {
  let isOpen = props.isOpen;
  if ((isOpen === null)) {
    isOpen = true;
  }
  let onToggle = props.onToggle;
  let height = (props.height || 200);
  let onHeightChange = props.onHeightChange;
  let original_output = (props.output || "");
  let output = useMemo(() => {
    let pattern = Reflect.construct(RegExp, ["<==START PRINT GRAPH==>.*?<==END PRINT GRAPH==>", "gs"]);
    return original_output.replace(pattern, "");
  }, [original_output]);
  let errors = (props.errors || "");
  let logs = (props.logs || "");
  let onClearOutput = props.onClearOutput;
  let onClearErrors = props.onClearErrors;
  let onClearLogs = props.onClearLogs;
  const [activeTab, setActiveTab] = useState("output");
  const [isMaximized, setIsMaximized] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  let tabs = [{"id": "output", "icon": Terminal, "label": "Output", "content": output, "onClear": onClearOutput}, {"id": "errors", "icon": AlertCircle, "label": "Problems", "content": errors, "onClear": onClearErrors, "badge": (((errors !== "") && errors.split("\\n").length) || 0)}, {"id": "logs", "icon": FileText, "label": "Logs", "content": logs, "onClear": onClearLogs}];
  let activeTabData = tabs.find(t => {
    return (t["id"] === activeTab);
  });
  function handleMouseDown(e) {
    setIsDragging(true);
    let startY = e.clientY;
    let startHeight = height;
    function onMouseMove(moveE) {
      let deltaY = (startY - moveE.clientY);
      let newHeight = (startHeight + deltaY);
      newHeight = Math.max(100, Math.min(500, newHeight));
      onHeightChange(newHeight);
    }
    function onMouseUp() {
      setIsDragging(false);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    }
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }
  if (!isOpen) {
    return __jacJsx("div", {"className": "h-8 bg-surface border-t border-border flex items-center px-3 gap-2"}, [tabs.map(tab => {
      let Icon = tab["icon"];
      let badgeValue = ((("badge" in tab) && tab["badge"]) || 0);
      let hasBadge = (badgeValue > 0);
      return __jacJsx("button", {"key": tab["id"], "onClick": () => {
        setActiveTab(tab["id"]);
        onToggle();
      }, "className": "flex items-center gap-1.5 px-2 py-1 text-xs text-text-secondary hover:text-text-primary transition-colors"}, [__jacJsx(Icon, {"size": 12}, []), __jacJsx("span", {}, [tab["label"]]), (hasBadge && __jacJsx("span", {"className": "px-1 py-0.5 bg-error text-error-foreground text-[10px] rounded-full min-w-[16px] text-center"}, [badgeValue]))]);
    }), __jacJsx("button", {"onClick": onToggle, "className": "ml-auto p-1 text-text-secondary hover:text-text-primary transition-colors"}, [__jacJsx(ChevronUp, {"size": 14}, [])])]);
  }
  let panelHeight = ((isMaximized && "h-[60vh]") || `h-[${height}px]`);
  return __jacJsx("div", {"className": cn("bg-surface border-t border-border flex flex-col transition-all", ((isMaximized && "h-[60vh]") || "")), "style": ((isMaximized && {}) || {"height": `${height}px`})}, [__jacJsx("div", {"className": cn("h-1 cursor-ns-resize hover:bg-primary/30 transition-colors", (isDragging && "bg-primary/50")), "onMouseDown": handleMouseDown}, []), __jacJsx("div", {"className": "flex items-center justify-between h-8 px-2 border-b border-border"}, [__jacJsx("div", {"className": "flex items-center gap-1"}, [tabs.map(tab => {
    let Icon = tab["icon"];
    let isActive = (activeTab === tab["id"]);
    let hasBadge = (((("badge" in tab) && tab["badge"]) || 0) > 0);
    return __jacJsx("button", {"key": tab["id"], "onClick": () => {
      setActiveTab(tab["id"]);
    }, "className": cn("flex items-center gap-1.5 px-2.5 py-1 text-xs rounded-t transition-colors", ((isActive && "bg-background text-text-primary border-t-2 border-primary") || "text-text-secondary hover:text-text-primary"))}, [__jacJsx(Icon, {"size": 12}, []), __jacJsx("span", {}, [tab["label"]]), (hasBadge && __jacJsx("span", {"className": "px-1 py-0.5 bg-error text-error-foreground text-[10px] rounded-full min-w-[14px] text-center"}, [tab["badge"]]))]);
  })]), __jacJsx("div", {"className": "flex items-center gap-1"}, [((activeTabData && activeTabData["onClear"]) && __jacJsx("button", {"onClick": activeTabData["onClear"], "className": "p-1 text-text-secondary hover:text-text-primary transition-colors", "title": "Clear"}, [__jacJsx(Eraser, {"size": 12}, [])])), __jacJsx("button", {"onClick": () => {
    setIsMaximized(!isMaximized);
  }, "className": "p-1 text-text-secondary hover:text-text-primary transition-colors", "title": ((isMaximized && "Restore") || "Maximize")}, [((isMaximized && __jacJsx(Minimize2, {"size": 12}, [])) || __jacJsx(Maximize2, {"size": 12}, []))]), __jacJsx("button", {"onClick": onToggle, "className": "p-1 text-text-secondary hover:text-text-primary transition-colors", "title": "Minimize"}, [__jacJsx(ChevronDown, {"size": 14}, [])])])]), __jacJsx("div", {"className": "flex-1 overflow-auto bg-background"}, [__jacJsx("pre", {"className": "p-3 text-xs font-mono text-text-secondary whitespace-pre-wrap"}, [((activeTabData && activeTabData["content"]) || "No output")])])]);
}
export {DockableConsole};